import http from "../utils/http"

/**
 * รับข้อมูลการเริ่มต้นคําสั่งซื้อ
 * @param {object} params
 */
export function payment(params) {
    return http({
        url: "/bundling/api/ordercreate/payment",
        data: params,
        forceLogin: true
    })
}

/**
 * รับข้อมูลการเริ่มต้นคําสั่งซื้อ
 * @param {object} params
 */
export function calculate(params) {
    return http({
        url: "/bundling/api/ordercreate/calculate",
        data: params,
        forceLogin: true
    })
}

/**
 * การสร้างคําสั่งซื้อ
 * @param {object} params
 */
export function orderCreate(params) {
    return http({
        url: "/bundling/api/ordercreate/create",
        data: params,
        forceLogin: true
    })
}

/**
 * รับรายการข้อเสนอ
 * @param {object} params
 */
export function detail(params) {
    return http({
        url: "/bundling/api/bundling/detail",
        data: params
    })
}
